"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
class BannerService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key, token = '') {
        this.RESOURCE = 'banner';
        this.getStudent = async (student, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${student.ou}/get-student/${student.student_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getRef = async (studentData, student, user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${student.ou}/payment-reference`;
            const body = JSON.stringify({
                infCurricular: studentData[0],
                userSession: user
            });
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.validateRef = async (studentData, student) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${student.ou}/payment-reference/validate`;
            const infCurricular = JSON.stringify(studentData[0]);
            const response = await axios_1.default.post(URL, infCurricular, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getPaymentHistory = async (student, params, abort) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${student.ou}/get-payment-history/${student.student_id}`;
            const objectToQueryString = (obj) => {
                return Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            };
            const response = await axios_1.default.get(`${url}?${objectToQueryString(params)}`, { headers: { 'x-api-key': this.key }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getPaymentHistoryMultiOU = async (student, params, abort) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/payments/treasury/history/${student.student_id}`;
            const objectToQueryString = (obj) => {
                return Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            };
            const response = await axios_1.default.get(`${url}?${objectToQueryString(params)}`, { headers: { 'x-api-key': this.key }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentMultiOU = async (student, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/payments/treasury/debts/${student.student_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.key = key;
        this.token = token;
    }
}
exports.BannerService = BannerService;
